<template>
  <tr v-if="$parent.$parent.$parent.rerender">
    <template v-if="purchasedEquipment === 21">
      <td>{{ index + 1 }}</td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_VID_GROUP_ID')
        }"
        style="width: 15%"
      >
        <input type="hidden" v-model="item.ID" />
        <!-- Группа -->
        <p
          v-if="
            purchasedEquipment === 21 && $parent.$parent.$parent.projectDisabled
          "
        >
          {{ cGroupText }}
        </p>
        <select
          v-if="
            purchasedEquipment === 21 &&
              !$parent.$parent.$parent.projectDisabled
          "
          @change="$parent.removeError(index, 'UF_VID_GROUP_ID')"
          v-model="item.UF_VID_GROUP_ID"
          class="sel-dropdown i-main-style"
          style="width: 100%"
        >
          <!-- :disabled="$parent.$parent.$parent.projectDisabled" -->
          <option
            v-for="g in $parent.directory.tree_group_med_oborudovanie"
            v-bind:value="g.ID"
            v-bind:key="g.ID"
            v-if="
              (g.UF_SUPPORT_PROGRAM_ID.indexOf(project.UF_SUPPORT_PROG_ID) >=
                0 &&
                g.UF_IS_SET_BLOCK_FIELD === 0 &&
                g.CODE == 'serialization') ||
                g.CODE == 'aggregation' ||
                g.CODE == 'equipping_finished_goods_warehouses' ||
                g.CODE == 'server_equipment' ||
                g.CODE == 'software_licenses' ||
                g.CODE == 'additional_services_and_options'
            "
            v-text="g.NAME"
          ></option>
        </select>

        <div class="error-text"></div>
      </td>
      <td>{{ cGroupCode }}</td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_VID_ID')
        }"
        style="width: 45%;
            margin-left: 10px;
            margin-right: 10px;
          "
      >
        <!-- Вид оборудования -->
        <p
          v-if="
            purchasedEquipment === 21 && $parent.$parent.$parent.projectDisabled
          "
        >
          {{ cGroupVidText }}
        </p>
        <select
          v-if="
            purchasedEquipment === 21 &&
              !$parent.$parent.$parent.projectDisabled
          "
          @change="$parent.removeError(index, 'UF_VID_ID')"
          v-model="item.UF_VID_ID"
          class="sel-dropdown i-main-style"
          style="
            width: 99%;
            margin-left: 10px;
            margin-right: 10px;
          "
        >
          <!-- :disabled="
            $parent.$parent.$parent.projectDisabled || purchasedEquipment !== 21
          "-->
          <option
            v-for="g in cGroup"
            v-bind:value="g.ID"
            v-bind:key="g.ID"
            v-text="g.NAME"
          ></option>
        </select>
        <div class="error-text"></div>
      </td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_DESCRIPTION')
        }"
        style="
          width: 40%;
          padding-left: 10px;
          padding-top: 24px;
        "
      >
        <!-- Описание оборудования -->
        <textarea
          @keyup="$parent.removeError(index, 'UF_DESCRIPTION')"
          v-model="item.UF_DESCRIPTION"
          class="i-main-style t-co-executor-style"
          style="width: 97%;"
        ></textarea>
        <span class="frp-input-description"
          >Доступно для ввода символов:
          {{ countEntChar(item.UF_DESCRIPTION, 200) }}
        </span>
        <!-- :disabled="$parent.$parent.$parent.projectDisabled" -->
        <div class="error-text"></div>
      </td>
      <td>
        от
        <input
          class="i-main-style i-wid-29"
          @keypress="isNumber($event)"
          v-model="item.UF_COUNT_FROM"
        />
        до
        <input
          class="i-main-style i-wid-29"
          @keypress="isNumber($event)"
          v-model="item.UF_COUNT_TO"
        />
      </td>
      <td>
        <a
          v-show="!$parent.$parent.$parent.projectDisabled"
          v-on:click="$parent.deleteItem(index)"
          class="link-delete-row"
        ></a>
      </td>
    </template>
    <!-- Отображение если purchasedEquipment !== 21 -->
    <template
      v-if="
        purchasedEquipment !== 21 &&
          purchasedEquipment !== 37 &&
          purchasedEquipment !== 38
      "
    >
      <td>{{ index + 1 }}</td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_VID_GROUP_ID')
        }"
        style="width: 20%;"
      >
        <input type="hidden" v-model="item.ID" />
        <!-- Группа -->
        <!-- <p v-if="purchasedEquipment !== 21">{{ cGroupTextBlockField_1 }}</p> -->
        <select
          v-if="purchasedEquipment !== 21 && purchasedEquipment !== 37"
          @change="$parent.removeError(index, 'UF_VID_GROUP_ID')"
          v-model="item.UF_VID_GROUP_ID"
          class="sel-dropdown i-main-style"
          style="width: 100%"
        >
          <!-- :disabled="true" -->
          <option
            v-for="g in $parent.directory.tree_group_med_oborudovanie"
            v-bind:value="g.ID"
            v-bind:key="g.ID"
            v-if="
              (g.UF_SUPPORT_PROGRAM_ID.indexOf(project.UF_SUPPORT_PROG_ID) >=
                0 &&
                g.CODE == 'serialization') ||
                g.CODE == 'aggregation' ||
                g.CODE == 'server_equipment' ||
                g.CODE == 'software_licenses2' ||
                g.CODE == 'machine_vision_system' ||
                g.CODE == 'services' ||
                g.CODE == 'equipping_finished_goods_warehouses'

              // && g.UF_IS_SET_BLOCK_FIELD === 1
            "
            v-text="g.NAME"
          ></option>
        </select>

        <div class="error-text"></div>
      </td>
      <td>{{ cGroupCode }}</td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_VID_ID')
        }"
        style="width: 20%;"
      >
        <!-- Вид оборудования -->
        <!-- <p
          v-if="purchasedEquipment !== 21"
          style="
            margin-left: 10px;
            margin-right: 10px;
          "
        >
          {{ cGroupVidTextBlockField_1 }}
        </p>-->
        <select
          @change="$parent.removeError(index, 'UF_VID_ID')"
          v-model="item.UF_VID_ID"
          class="sel-dropdown i-main-style"
          style="
            width: 99%;
            margin-left: 10px;
            margin-right: 10px;
          "
        >
          <!-- :disabled="
            $parent.$parent.$parent.projectDisabled || purchasedEquipment !== 21
          "-->
          <option
            v-for="g in cGroup"
            v-bind:value="g.ID"
            v-bind:key="g.ID"
            v-text="g.NAME"
          ></option>
        </select>
        <div class="error-text"></div>
      </td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_DESCRIPTION')
        }"
        style="
          width: 20%;
          padding-left: 10px;
          padding-top: 24px;
        "
      >
        <!-- Описание оборудования -->
        <textarea
          @keyup="$parent.removeError(index, 'UF_DESCRIPTION')"
          v-model="item.UF_DESCRIPTION"
          class="i-main-style t-co-executor-style"
          style="width: 97%;"
        ></textarea>
        <span class="frp-input-description"
          >Доступно для ввода символов:
          {{ countEntChar(item.UF_DESCRIPTION, 200) }}
        </span>
        <!-- :disabled="$parent.$parent.$parent.projectDisabled" -->
        <div class="error-text"></div>
      </td>
      <td>
        от
        <input
          class="i-main-style i-wid-29"
          @keypress="isNumber($event)"
          v-model="item.UF_COUNT_FROM"
        />
        до
        <input
          class="i-main-style i-wid-29"
          @keypress="isNumber($event)"
          v-model="item.UF_COUNT_TO"
        />
      </td>
      <td>
        <a
          v-show="!$parent.$parent.$parent.projectDisabled"
          v-on:click="$parent.deleteItem(index)"
          class="link-delete-row"
        ></a>
      </td>
    </template>

    <template v-if="purchasedEquipment === 37 || purchasedEquipment === 38">
      <td>{{ index }}</td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_VID_GROUP_ID')
        }"
        style="width: 15%"
      >
        <input type="hidden" v-model="item.ID" />
        <!-- Группа -->
        <p
          v-if="
            (purchasedEquipment === 37 || purchasedEquipment === 38) &&
              $parent.$parent.$parent.projectDisabled
          "
        >
          {{ cGroupText }}
        </p>
        <select
          v-if="
            (purchasedEquipment === 37 || purchasedEquipment === 38) &&
              !$parent.$parent.$parent.projectDisabled
          "
          @change="$parent.removeError(index, 'UF_VID_GROUP_ID')"
          v-model="item.UF_VID_GROUP_ID"
          class="sel-dropdown i-main-style"
          style="width: 100%"
        >
          <!-- :disabled="$parent.$parent.$parent.projectDisabled" -->
          <option
            v-for="g in $parent.directory.tree_group_med_oborudovanie"
            v-bind:value="g.ID"
            v-bind:key="g.ID"
            v-if="
              (g.UF_SUPPORT_PROGRAM_ID.indexOf(project.UF_SUPPORT_PROG_ID) >=
                0 &&
                g.UF_IS_SET_BLOCK_FIELD === 0 &&
                g.CODE == 'serialization') ||
                g.CODE == 'aggregation' ||
                g.CODE == 'equipping_finished_goods_warehouses' ||
                g.CODE == 'server_equipment' ||
                g.CODE == 'software_licenses2' ||
                g.CODE == 'machine_vision_system' ||
                g.CODE == 'services'
            "
            v-text="g.NAME"
          ></option>
        </select>

        <div class="error-text"></div>
      </td>
      <td>{{ cGroupCode }}</td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_VID_ID')
        }"
        style="width: 45%;
            margin-left: 10px;
            margin-right: 10px;
          "
      >
        <!-- Вид оборудования -->
        <p
          v-if="
            (purchasedEquipment === 37 || purchasedEquipment === 38) &&
              $parent.$parent.$parent.projectDisabled
          "
        >
          {{ cGroupVidText }}
        </p>
        <select
          v-if="
            (purchasedEquipment === 37 || purchasedEquipment === 38) &&
              !$parent.$parent.$parent.projectDisabled
          "
          @change="$parent.removeError(index, 'UF_VID_ID')"
          v-model="item.UF_VID_ID"
          class="sel-dropdown i-main-style"
          style="
            width: 99%;
            margin-left: 10px;
            margin-right: 10px;
          "
        >
          <!-- :disabled="
            $parent.$parent.$parent.projectDisabled || purchasedEquipment !== 21
          "-->
          <option
            v-for="g in cGroup"
            v-bind:value="g.ID"
            v-bind:key="g.ID"
            v-text="g.NAME"
          ></option>
        </select>
        <div class="error-text"></div>
      </td>
      <td
        v-bind:class="{
          'has-error': $parent.hasError(index, 'UF_DESCRIPTION')
        }"
        style="
          width: 40%;
          padding-left: 10px;
        "
      >
        <!-- Описание оборудования -->
        <textarea
          @keyup="$parent.removeError(index, 'UF_DESCRIPTION')"
          v-model="item.UF_DESCRIPTION"
          class="i-main-style t-co-executor-style"
          style="width: 97%;"
        ></textarea>
        <span class="frp-input-description"
          >Доступно для ввода символов:
          {{ countEntChar(item.UF_DESCRIPTION, 200) }}
        </span>
        <!-- :disabled="$parent.$parent.$parent.projectDisabled" -->
        <div class="error-text"></div>
      </td>
      <td>
        от
        <input
          class="i-main-style i-wid-29"
          @keypress="isNumber($event)"
          v-model="item.UF_COUNT_FROM"
        />
        до
        <input
          class="i-main-style i-wid-29"
          @keypress="isNumber($event)"
          v-model="item.UF_COUNT_TO"
        />
      </td>
      <td>
        <a
          v-show="!$parent.$parent.$parent.projectDisabled"
          v-on:click="$parent.deleteItem(index)"
          class="link-delete-row"
        ></a>
      </td>
    </template>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["item", "index"],
  name: "system_equipment_list_markirovka",
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    countEntChar(value, limit) {
      if (value) {
        return value.length > limit ? 0 : limit - value.length;
      }
      return limit;
    }
  },
  computed: {
    ...mapGetters(["project", "directory"]),
    cGroup() {
      if (this.item.UF_VID_GROUP_ID < 1) {
        return [];
      }
      let t = null;
      t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 0
      );
      if (t.length > 0 && this.purchasedEquipment === 21 && t[0].CHILD) {
        const filterChildVersion = t[0].CHILD.filter(
          child => child.VERSION === 1
        );
        return filterChildVersion;
      }
      if (t.length > 0 && this.purchasedEquipment !== 21 && t[0].CHILD) {
        const filterChildVersion = t[0].CHILD.filter(
          child => child.VERSION === 2
        );

        return filterChildVersion;
      }

      return [];
    },
    purchasedEquipment() {
      let t = this.directory.tree_industry.filter(
        c => c.ID === this.$parent.project.UF_INDUSTRY_ID
      );
      if (t.length > 0) {
        console.log(
          "this.$parent.directory.tree_group_med_oborudovanie: ",
          JSON.parse(
            JSON.stringify(this.$parent.directory.tree_group_med_oborudovanie)
          )
        );
        return t[0].CODE;
      }
      return [];
    },
    cGroupText() {
      let t = null;
      t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 0
      );
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    cGroupVidText() {
      let t = null;
      t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 0
      );
      if (t.length > 0) {
        return t[0].CHILD[0].NAME;
      }
      return "";
    },
    cGroupCode() {
      let t = null;
      t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 0
      );
      if (t.length > 0) {
        let tv = null;
        console.log(t);
        tv = t[0].CHILD.filter(c => c.ID === this.item.UF_VID_ID);
        if (tv.length) return tv[0].CODE;
      }
      return "";
    },
    cGroupTextBlockField_1() {
      let t = null;
      t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 1
      );
      if (t.length > 0) {
        return t[0].NAME;
      }
      return "";
    }
    // cGroupVidTextBlockField_1() {
    //   let t = null;
    //   t = this.$parent.directory.tree_group_med_oborudovanie.filter(
    //     c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 1
    //   );
    //   if (t.length > 0) {
    //     return t[0].CHILD[0].NAME;
    //   }
    //   return "";
    // }
  }
};
</script>

<style scoped></style>
